import { render, staticRenderFns } from "./DepositNotFound.vue?vue&type=template&id=0eb23cb9&scoped=true&"
import script from "./DepositNotFound.vue?vue&type=script&lang=js&"
export * from "./DepositNotFound.vue?vue&type=script&lang=js&"
import style0 from "./DepositNotFound.vue?vue&type=style&index=0&id=0eb23cb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb23cb9",
  null
  
)

export default component.exports